import { buildIsServiceFn } from '../../utils';

import { SERVICE_TYPES_DELIVERY } from '../../constants';

const isDeliveryService = buildIsServiceFn(SERVICE_TYPES_DELIVERY);

export default isDeliveryService;
